import { render, staticRenderFns } from "./doctor_recommendation.vue?vue&type=template&id=4df37dbc&scoped=true&"
import script from "./doctor_recommendation.vue?vue&type=script&lang=js&"
export * from "./doctor_recommendation.vue?vue&type=script&lang=js&"
import style0 from "./doctor_recommendation.vue?vue&type=style&index=0&id=4df37dbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df37dbc",
  null
  
)

export default component.exports